import React from 'react';

const DividerIcon = () => (
  <svg
    width='4'
    height='5'
    viewBox='0 0 4 5'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.75 2.5C3.75 2.84612 3.64736 3.18446 3.45507 3.47225C3.26278 3.76003 2.98947 3.98434 2.6697 4.11679C2.34993 4.24924 1.99806 4.2839 1.65859 4.21637C1.31913 4.14885 1.00731 3.98218 0.762564 3.73744C0.517822 3.4927 0.351151 3.18087 0.283627 2.84141C0.216102 2.50194 0.250758 2.15007 0.383212 1.8303C0.515665 1.51053 0.739967 1.23722 1.02775 1.04493C1.31554 0.852636 1.65388 0.75 2 0.75C2.46413 0.75 2.90925 0.934375 3.23744 1.26256C3.56563 1.59075 3.75 2.03587 3.75 2.5Z'
      fill='#171717'
      fillOpacity='0.15'
    />
  </svg>
);

export default DividerIcon;
